import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navigation from './Navigation';
import Loading from './Loading';
import './Layout.css';

const Layout = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  useEffect(() => {
    // // Simulate initial loading
    // const timer = setTimeout(() => {
      setIsLoading(false);
    // }, 2000);

    return () => {
    }
  }, []);

  const toggleNavigation = () => {
    setIsNavigationOpen(!isNavigationOpen);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="layout">
      <div className="layout__bg-grid"></div>
      <div className="layout__bg-particles"></div>
      
      {/* Navigation */}
      <Navigation 
        isOpen={isNavigationOpen}
        onToggle={toggleNavigation}
      />
      
      {/* Main Content */}
      <motion.main 
        className="layout__main"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <AnimatePresence mode="wait">
          {children}
        </AnimatePresence>
      </motion.main>
      
      {/* System Status Bar */}
      <div className="layout__status-bar">
        <div className="layout__status-info">
          <span className="layout__status-item">
            <span className="layout__status-dot"></span>
            SYSTEM ONLINE
          </span>
          <span className="layout__status-item">
            CYPHER.NET
          </span>
          <span className="layout__status-item">
            {new Date().toLocaleTimeString('en-US', { 
              hour12: false,
              timeZone: 'UTC'
            })} UTC
          </span>
        </div>
      </div>

      {/* Navigation Overlay */}
      <AnimatePresence>
        {isNavigationOpen && (
          <motion.div
            className="layout__nav-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={toggleNavigation}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Layout;